<template>
  <div class="shape__picker">
    <ul class="shape__picker-list">
      <li v-for="(shapeItem, key) in shapes" :key="key" class="shape__picker-list-item" :class="{'is-selected': key === shape}" v-on:click="onSVGClick(key, shapeItem.path)" >
        <svg xmlns="http://www.w3.org/2000/svg" :viewBox="shapeItem.viewbox" width="100%" height="100%" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path :d="shapeItem.path" />
        </svg>
      </li>
    </ul>
    <div class="shape__picker-border">
      <color-picker label="Stroke" :value="stroke" @pick="onPickStrokeColor" :lastUsedColors="lastUsedColors" @updateLastUsedColors="updateLastUsedColors"/>
      <input type="number" min="0" v-model="weight" max="10" @change="onChangeWeight" />
    </div>
    <color-picker label="Fill" :value="fill" @pick="onPickFillColor" :lastUsedColors="lastUsedColors" @updateLastUsedColors="updateLastUsedColors"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ColorPicker from '../core/colorPicker'
import shapes from './../shapes/svgpath.json'
import { transparentColor } from './../viewer/utils'

export default {
  name: 'shapePicker',

  components: {
    'color-picker': ColorPicker
  },

  props: {
    modelItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      shapes: shapes,
      shape: null,
      stroke: null,
      fill: null,
      weight: null
    }
  },

  computed: {
    ...mapState(['lastUsedColors']),
  },

  watch: {
    'modelItem.value': 'init'
  },

  created() {
    this.init()
    // reemit for defaults
    // this.emit()
  },

  methods: {
  ...mapMutations(['updateLastUsedColors']),

    init: function () {
      let val = this.modelItem.value
      // set default values on shape
      /*
      if (!val.shape) {
        val.shape = "square"
        val.stroke = transparentColor()
        val.fill = transparentColor()
        val.weight = 0
      }
      */
      transparentColor()
      this.shape = val.shape
      this.stroke = val.stroke
      this.weight = val.weight
      this.fill = val.fill
    },
  
    onSVGClick: function (shape) {
      this.shape = shape
      this.emit()
    },
  
    onPickStrokeColor: function (value) {
      this.stroke = value
      this.emit()
    },
  
    onPickFillColor: function (value) {
      this.fill = value
      this.emit()
    },
  
    onChangeWeight: function () {
      this.emit()
    },
  
    emit: function () {
      const { shape, stroke, fill, weight } = this

      this.modelItem.value = {
        shape,
        stroke,
        fill,
        weight
      }

      this.$emit('pick', this.modelItem.value)
    }
  }
}
</script>
